import { counterpartyInsolvencyTooltip } from "helpers/bid";
import { HiddenDataWrapper, hiddenUserData } from "helpers/hiddenData";
import Tooltip from "rc-tooltip";
import React from "react";

const CargoOwner = ({ cargoOwnerDictionaryItem, sharedAccess, roles, modal }) => {
    if (!cargoOwnerDictionaryItem) {
        return null;
    }
    const { insolvencyRegistryEntry } = cargoOwnerDictionaryItem;

    return (
        <>
            <div className="show-bid__main-info--title">Контрагент</div>
            <div className="show-bid__main-info--value" data-test-id="cargo-owner">
                {sharedAccess && !roles.isTruckingOrganizationDispatcher && (
                    <Tooltip
                        overlay="Контрагенту предоставлен доступ"
                        overlayClassName="notifys__tooltip"
                        placement="bottom"
                    >
                        <i className="icon-uEA49-eye b-table__compound-icon pr-1 text-primary" />
                    </Tooltip>
                )}
                {hiddenUserData(
                    cargoOwnerDictionaryItem.name,
                    { type: "title" },
                    roles.isTruckingOrganizationDispatcher,
                )}
                {insolvencyRegistryEntry && insolvencyRegistryEntry.insolvencyRank > 0 && (
                    <HiddenDataWrapper>
                        <br />
                        {counterpartyInsolvencyTooltip(insolvencyRegistryEntry, modal)}
                    </HiddenDataWrapper>
                )}
            </div>
        </>
    );
};

export default CargoOwner;
